<template>
  <b-button
    @click="getInvitationLink(agent)"
    variant="flat-secondary"
    class="font-weight-bolder"
  >
    <div
      v-if="loading"
      class=""
    >
      <b-spinner
        small
        style="width: 1.3rem; height: 1.3rem;"
      />
      <span class="sr-only">Loading...</span>
    </div>
    <feather-icon
      v-else
      icon="CopyIcon"
      size="20"
    />

  </b-button>
</template>

<script>
  import { BButton, BSpinner } from "bootstrap-vue";
  export default {
    props: ["agent", "event"],
    components: {
      BSpinner,
      BButton,
    },
    data() {
      return {
        loading: false,
      };
    },
    methods: {
      getInvitationLink(agent) {
        if (this.loading) return;

        this.loading = true;

        const requestData = {
          method: "post",
          url: `events/${this.event.id}/get-invitation-link`,
          data: {
            agent: agent.id,
          },
        };

        this.$http(requestData)
          .then((response) => {
            // console.log(response.data);
            navigator.clipboard.writeText(response.data.data.inviteLink);
            this.loading = false;
            this.$bvToast.toast(
               this.$t("Invitation link copied to your clipboard") ,
              {
                title: this.$t("Done"),
                variant: "success",
                solid: true,
              }
            );
           
          })
          .catch((err) => {
            let message = this.$t(`Unable to get invitation link!`);
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;
            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
              solid: true,
            });
            this.loading = false;
            console.log(err);
          });
      },
    },
  };
</script>

<style>
</style>